import { c as _c } from "react/compiler-runtime";
import { parseAsFloat, parseAsInteger, parseAsString, useQueryStates } from "nuqs";
export function useGeosearchState() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      location: parseAsString,
      lat: parseAsFloat,
      lng: parseAsFloat,
      placeId: parseAsString,
      radius: parseAsInteger
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQueryStates(t0);
}